/* eslint-disable @typescript-eslint/consistent-indexed-object-style , @typescript-eslint/consistent-type-assertions , @typescript-eslint/consistent-type-definitions , @typescript-eslint/no-redeclare , @typescript-eslint/no-invalid-void-type , @typescript-eslint/no-unnecessary-condition , @typescript-eslint/no-unsafe-assignment , antfu/top-level-function , @typescript-eslint/no-misused-spread */
/**
 * Generated by orval 🍺
 * Do not edit manually!
 * Forgejo API
 * This documentation describes the Forgejo API.
 * OpenAPI spec version: 14.0.0-54-d7af2c76+gitea-1.22.0
 */
import { useMutation, useQuery } from "@tanstack/vue-query";
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import { computed, unref } from "vue";
import type { MaybeRef } from "vue";

/**
 * ExternalTracker represents settings for external tracker
 */
export interface ExternalTracker {
  /** External Issue Tracker URL Format. Use the placeholders {user}, {repo} and {index} for the username, repository name and issue index. */
  external_tracker_format?: string;
  /** External Issue Tracker issue regular expression */
  external_tracker_regexp_pattern?: string;
  /** External Issue Tracker Number Format, either `numeric`, `alphanumeric`, or `regexp` */
  external_tracker_style?: string;
  /** URL of external issue tracker. */
  external_tracker_url?: string;
}

/**
 * ExternalWiki represents setting for external wiki
 */
export interface ExternalWiki {
  /** URL of external wiki. */
  external_wiki_url?: string;
}

/**
 * InternalTracker represents settings for internal tracker
 */
export interface InternalTracker {
  /** Let only contributors track time (Built-in issue tracker) */
  allow_only_contributors_to_track_time?: boolean;
  /** Enable dependencies for issues and pull requests (Built-in issue tracker) */
  enable_issue_dependencies?: boolean;
  /** Enable time tracking (Built-in issue tracker) */
  enable_time_tracker?: boolean;
}

/**
 * ObjectFormatName of the underlying git repository
 */
export type RepositoryObjectFormatName =
  (typeof RepositoryObjectFormatName)[keyof typeof RepositoryObjectFormatName];

export const RepositoryObjectFormatName = {
  sha1: "sha1",
  sha256: "sha256",
} as const;

/**
 * User represents a user
 */
export interface User {
  /** Is user active */
  active?: boolean;
  /** URL to the user's avatar */
  avatar_url?: string;
  created?: string;
  /** the user's description */
  description?: string;
  email?: string;
  /** user counts */
  followers_count?: number;
  following_count?: number;
  /** the user's full name */
  full_name?: string;
  /** URL to the user's profile page */
  html_url?: string;
  /** the user's id */
  id?: number;
  /** Is the user an administrator */
  is_admin?: boolean;
  /** User locale */
  language?: string;
  last_login?: string;
  /** the user's location */
  location?: string;
  /** the user's username */
  login?: string;
  /** the user's authentication sign-in name. */
  login_name?: string;
  /** Is user login prohibited */
  prohibit_login?: boolean;
  /** the user's pronouns */
  pronouns?: string;
  /** Is user restricted */
  restricted?: boolean;
  /** The ID of the user's Authentication Source */
  source_id?: number;
  starred_repos_count?: number;
  /** User visibility level option: public, limited, private */
  visibility?: string;
  /** the user's website */
  website?: string;
}

/**
 * Permission represents a set of permissions
 */
export interface Permission {
  admin?: boolean;
  pull?: boolean;
  push?: boolean;
}

/**
 * Organization represents an organization
 */
export interface Organization {
  avatar_url?: string;
  description?: string;
  email?: string;
  full_name?: string;
  id?: number;
  location?: string;
  name?: string;
  repo_admin_change_team_access?: boolean;
  /** deprecated */
  username?: string;
  visibility?: string;
  website?: string;
}

export type TeamPermission =
  (typeof TeamPermission)[keyof typeof TeamPermission];

export const TeamPermission = {
  none: "none",
  read: "read",
  write: "write",
  admin: "admin",
  owner: "owner",
} as const;

export type TeamUnitsMap = { [key: string]: string };

/**
 * Team represents a team in an organization
 */
export interface Team {
  can_create_org_repo?: boolean;
  description?: string;
  id?: number;
  includes_all_repositories?: boolean;
  name?: string;
  organization?: Organization;
  permission?: TeamPermission;
  units?: string[];
  units_map?: TeamUnitsMap;
}

/**
 * RepoTransfer represents a pending repo transfer
 */
export interface RepoTransfer {
  doer?: User;
  recipient?: User;
  teams?: Team[];
}

/**
 * Repository represents a repository
 */
export interface Repository {
  allow_fast_forward_only_merge?: boolean;
  allow_merge_commits?: boolean;
  allow_rebase?: boolean;
  allow_rebase_explicit?: boolean;
  allow_rebase_update?: boolean;
  allow_squash_merge?: boolean;
  archived?: boolean;
  archived_at?: string;
  avatar_url?: string;
  clone_url?: string;
  created_at?: string;
  default_allow_maintainer_edit?: boolean;
  default_branch?: string;
  default_delete_branch_after_merge?: boolean;
  default_merge_style?: string;
  default_update_style?: string;
  description?: string;
  empty?: boolean;
  external_tracker?: ExternalTracker;
  external_wiki?: ExternalWiki;
  fork?: boolean;
  forks_count?: number;
  full_name?: string;
  globally_editable_wiki?: boolean;
  has_actions?: boolean;
  has_issues?: boolean;
  has_packages?: boolean;
  has_projects?: boolean;
  has_pull_requests?: boolean;
  has_releases?: boolean;
  has_wiki?: boolean;
  html_url?: string;
  id?: number;
  ignore_whitespace_conflicts?: boolean;
  internal?: boolean;
  internal_tracker?: InternalTracker;
  language?: string;
  languages_url?: string;
  link?: string;
  mirror?: boolean;
  mirror_interval?: string;
  mirror_updated?: string;
  name?: string;
  /** ObjectFormatName of the underlying git repository */
  object_format_name?: RepositoryObjectFormatName;
  open_issues_count?: number;
  open_pr_counter?: number;
  original_url?: string;
  owner?: User;
  parent?: Repository;
  permissions?: Permission;
  private?: boolean;
  release_counter?: number;
  repo_transfer?: RepoTransfer;
  size?: number;
  ssh_url?: string;
  stars_count?: number;
  template?: boolean;
  topics?: string[];
  updated_at?: string;
  url?: string;
  watchers_count?: number;
  website?: string;
  wiki_branch?: string;
}

/**
 * SearchResults results of a successful search
 */
export interface SearchResults {
  data?: Repository[];
  ok?: boolean;
}

export interface APIValidationError {
  message?: string;
  url?: string;
}

export interface APINotFound {
  errors?: string[];
  message?: string;
  url?: string;
}

export interface APIForbiddenError {
  message?: string;
  url?: string;
}

/**
 * EditRepoOption options when editing a repository's properties
 */
export interface EditRepoOption {
  /** either `true` to allow fast-forward-only merging pull requests, or `false` to prevent fast-forward-only merging. */
  allow_fast_forward_only_merge?: boolean;
  /** either `true` to allow mark pr as merged manually, or `false` to prevent it. */
  allow_manual_merge?: boolean;
  /** either `true` to allow merging pull requests with a merge commit, or `false` to prevent merging pull requests with merge commits. */
  allow_merge_commits?: boolean;
  /** either `true` to allow rebase-merging pull requests, or `false` to prevent rebase-merging. */
  allow_rebase?: boolean;
  /** either `true` to allow rebase with explicit merge commits (--no-ff), or `false` to prevent rebase with explicit merge commits. */
  allow_rebase_explicit?: boolean;
  /** either `true` to allow updating pull request branch by rebase, or `false` to prevent it. */
  allow_rebase_update?: boolean;
  /** either `true` to allow squash-merging pull requests, or `false` to prevent squash-merging. */
  allow_squash_merge?: boolean;
  /** set to `true` to archive this repository. */
  archived?: boolean;
  /** either `true` to enable AutodetectManualMerge, or `false` to prevent it. Note: In some special cases, misjudgments can occur. */
  autodetect_manual_merge?: boolean;
  /** set to `true` to allow edits from maintainers by default */
  default_allow_maintainer_edit?: boolean;
  /** sets the default branch for this repository. */
  default_branch?: string;
  /** set to `true` to delete pr branch after merge by default */
  default_delete_branch_after_merge?: boolean;
  /** set to a merge style to be used by this repository: "merge", "rebase", "rebase-merge", "squash", "fast-forward-only", "manually-merged", or "rebase-update-only". */
  default_merge_style?: string;
  /** set to a update style to be used by this repository: "rebase" or "merge" */
  default_update_style?: string;
  /** a short description of the repository. */
  description?: string;
  /** enable prune - remove obsolete remote-tracking references when mirroring */
  enable_prune?: boolean;
  external_tracker?: ExternalTracker;
  external_wiki?: ExternalWiki;
  /** set the globally editable state of the wiki */
  globally_editable_wiki?: boolean;
  /** either `true` to enable actions unit, or `false` to disable them. */
  has_actions?: boolean;
  /** either `true` to enable issues for this repository or `false` to disable them. */
  has_issues?: boolean;
  /** either `true` to enable packages unit, or `false` to disable them. */
  has_packages?: boolean;
  /** either `true` to enable project unit, or `false` to disable them. */
  has_projects?: boolean;
  /** either `true` to allow pull requests, or `false` to prevent pull request. */
  has_pull_requests?: boolean;
  /** either `true` to enable releases unit, or `false` to disable them. */
  has_releases?: boolean;
  /** either `true` to enable the wiki for this repository or `false` to disable it. */
  has_wiki?: boolean;
  /** either `true` to ignore whitespace for conflicts, or `false` to not ignore whitespace. */
  ignore_whitespace_conflicts?: boolean;
  internal_tracker?: InternalTracker;
  /** set to a string like `8h30m0s` to set the mirror interval time */
  mirror_interval?: string;
  /** name of the repository */
  name?: string;
  /** either `true` to make the repository private or `false` to make it public.
Note: you will get a 422 error if the organization restricts changing repository visibility to organization
owners and a non-owner tries to change the value of private. */
  private?: boolean;
  /** either `true` to make this repository a template or `false` to make it a normal repository */
  template?: boolean;
  /** a URL with more information about the repository. */
  website?: string;
  /** sets the branch used for this repository's wiki. */
  wiki_branch?: string;
}

export type AttachmentType =
  (typeof AttachmentType)[keyof typeof AttachmentType];

export const AttachmentType = {
  attachment: "attachment",
  external: "external",
} as const;

/**
 * Attachment a generic attachment
 */
export interface Attachment {
  browser_download_url?: string;
  created_at?: string;
  download_count?: number;
  id?: number;
  name?: string;
  size?: number;
  type?: AttachmentType;
  uuid?: string;
}

/**
 * Label a label to an issue or a pr
 */
export interface Label {
  color?: string;
  description?: string;
  exclusive?: boolean;
  id?: number;
  is_archived?: boolean;
  name?: string;
  url?: string;
}

/**
 * StateType issue state type
 */
export type StateType = string;

/**
 * Milestone milestone is a collection of issues on one repository
 */
export interface Milestone {
  closed_at?: string;
  closed_issues?: number;
  created_at?: string;
  description?: string;
  due_on?: string;
  id?: number;
  open_issues?: number;
  state?: StateType;
  title?: string;
  updated_at?: string;
}

/**
 * PullRequestMeta PR info if an issue is a PR
 */
export interface PullRequestMeta {
  draft?: boolean;
  html_url?: string;
  merged?: boolean;
  merged_at?: string;
}

/**
 * RepositoryMeta basic repository information
 */
export interface RepositoryMeta {
  full_name?: string;
  id?: number;
  name?: string;
  owner?: string;
}

/**
 * Issue represents an issue in a repository
 */
export interface Issue {
  assets?: Attachment[];
  assignee?: User;
  assignees?: User[];
  body?: string;
  closed_at?: string;
  comments?: number;
  created_at?: string;
  due_date?: string;
  html_url?: string;
  id?: number;
  is_locked?: boolean;
  labels?: Label[];
  milestone?: Milestone;
  number?: number;
  original_author?: string;
  original_author_id?: number;
  pin_order?: number;
  pull_request?: PullRequestMeta;
  ref?: string;
  repository?: RepositoryMeta;
  state?: StateType;
  title?: string;
  updated_at?: string;
  url?: string;
  user?: User;
}

/**
 * CreateIssueOption options to create one issue
 */
export interface CreateIssueOption {
  /** deprecated */
  assignee?: string;
  assignees?: string[];
  body?: string;
  closed?: boolean;
  due_date?: string;
  /** list of label ids */
  labels?: number[];
  /** milestone id */
  milestone?: number;
  ref?: string;
  title: string;
}

/**
 * APIError is an api error with a message
 */
export interface APIError {
  message?: string;
  url?: string;
}

export interface APIRepoArchivedError {
  message?: string;
  url?: string;
}

/**
 * EditIssueOption options for editing an issue
 */
export interface EditIssueOption {
  /** deprecated */
  assignee?: string;
  assignees?: string[];
  body?: string;
  due_date?: string;
  milestone?: number;
  ref?: string;
  state?: string;
  title?: string;
  unset_due_date?: boolean;
  updated_at?: string;
}

export interface APIUnauthorizedError {
  message?: string;
  url?: string;
}

export interface AccessToken {
  id?: number;
  name?: string;
  scopes?: string[];
  sha1?: string;
  token_last_eight?: string;
}

/**
 * CreateAccessTokenOption options when create access token
 */
export interface CreateAccessTokenOption {
  name: string;
  scopes?: string[];
}

/**
 * APIValidationError is error format response related to input validation
 */
export type ValidationError = APIValidationError;

/**
 * APINotFound is a not found error response
 */
export type NotFound = APINotFound;

/**
 * APIEmpty is an empty response
 */
export type Empty = void;

/**
 * APIForbiddenError is a forbidden error response
 */
export type Forbidden = APIForbiddenError;

/**
 * IssueList
 */
export type IssueList = Issue[];

/**
 * APIError is error format response
 */
export type Error = APIError;

/**
 * APIRepoArchivedError is an error that is raised when an archived repo should be modified
 */
export type RepoArchivedError = APIRepoArchivedError;

/**
 * APIUnauthorizedError is a unauthorized error response
 */
export type Unauthorized = APIUnauthorizedError;

/**
 * AccessTokenList represents a list of API access token.
 */
export type AccessTokenList = AccessToken[];

export type RepoSearchParams = {
  /**
   * keyword
   */
  q?: string;
  /**
   * Limit search to repositories with keyword as topic
   */
  topic?: boolean;
  /**
   * include search of keyword within repository description
   */
  includeDesc?: boolean;
  /**
   * search only for repos that the user with the given id owns or contributes to
   */
  uid?: number;
  /**
   * repo owner to prioritize in the results
   */
  priority_owner_id?: number;
  /**
   * search only for repos that belong to the given team id
   */
  team_id?: number;
  /**
   * search only for repos that the user with the given id has starred
   */
  starredBy?: number;
  /**
   * include private repositories this user has access to (defaults to true)
   */
  private?: boolean;
  /**
   * show only public, private or all repositories (defaults to all)
   */
  is_private?: boolean;
  /**
   * include template repositories this user has access to (defaults to true)
   */
  template?: boolean;
  /**
   * show only archived, non-archived or all repositories (defaults to all)
   */
  archived?: boolean;
  /**
   * type of repository to search for. Supported values are "fork", "source", "mirror" and "collaborative"
   */
  mode?: string;
  /**
   * if `uid` is given, search only for repos that the user owns
   */
  exclusive?: boolean;
  /**
   * sort repos by attribute. Supported values are "alpha", "created", "updated", "size", "git_size", "lfs_size", "stars", "forks" and "id". Default is "alpha"
   */
  sort?: RepoSearchSort;
  /**
   * sort order, either "asc" (ascending) or "desc" (descending). Default is "asc", ignored if "sort" is not specified.
   */
  order?: RepoSearchOrder;
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
};

export type RepoSearchSort =
  (typeof RepoSearchSort)[keyof typeof RepoSearchSort];

export const RepoSearchSort = {
  alpha: "alpha",
  created: "created",
  updated: "updated",
  size: "size",
  git_size: "git_size",
  lfs_size: "lfs_size",
  id: "id",
  stars: "stars",
  forks: "forks",
} as const;

export type RepoSearchOrder =
  (typeof RepoSearchOrder)[keyof typeof RepoSearchOrder];

export const RepoSearchOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type IssueListIssuesParams = {
  /**
   * whether issue is open or closed
   */
  state?: IssueListIssuesState;
  /**
   * comma separated list of labels. Fetch only issues that have any of this labels. Non existent labels are discarded
   */
  labels?: string;
  /**
   * search string
   */
  q?: string;
  /**
   * filter by type (issues / pulls) if set
   */
  type?: IssueListIssuesType;
  /**
   * comma separated list of milestone names or ids. It uses names and fall back to ids. Fetch only issues that have any of this milestones. Non existent milestones are discarded
   */
  milestones?: string;
  /**
   * Only show items updated after the given time. This is a timestamp in RFC 3339 format
   */
  since?: string;
  /**
   * Only show items updated before the given time. This is a timestamp in RFC 3339 format
   */
  before?: string;
  /**
   * Only show items which were created by the given user
   */
  created_by?: string;
  /**
   * Only show items for which the given user is assigned
   */
  assigned_by?: string;
  /**
   * Only show items in which the given user was mentioned
   */
  mentioned_by?: string;
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
  /**
   * Type of sort
   */
  sort?: IssueListIssuesSort;
};

export type IssueListIssuesState =
  (typeof IssueListIssuesState)[keyof typeof IssueListIssuesState];

export const IssueListIssuesState = {
  closed: "closed",
  open: "open",
  all: "all",
} as const;

export type IssueListIssuesType =
  (typeof IssueListIssuesType)[keyof typeof IssueListIssuesType];

export const IssueListIssuesType = {
  issues: "issues",
  pulls: "pulls",
} as const;

export type IssueListIssuesSort =
  (typeof IssueListIssuesSort)[keyof typeof IssueListIssuesSort];

export const IssueListIssuesSort = {
  relevance: "relevance",
  latest: "latest",
  oldest: "oldest",
  recentupdate: "recentupdate",
  leastupdate: "leastupdate",
  mostcomment: "mostcomment",
  leastcomment: "leastcomment",
  nearduedate: "nearduedate",
  farduedate: "farduedate",
} as const;

export type UserGetTokensParams = {
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
};

/**
 * @summary Search for repositories
 */
export const repoSearch = (
  params?: MaybeRef<RepoSearchParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SearchResults>> => {
  params = unref(params);

  return axios.default.get(`/repos/search`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getRepoSearchQueryKey = (params?: MaybeRef<RepoSearchParams>) => {
  return ["repos", "search", ...(params ? [params] : [])] as const;
};

export const getRepoSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof repoSearch>>,
  TError = AxiosError<ValidationError>,
>(
  params?: MaybeRef<RepoSearchParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof repoSearch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getRepoSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof repoSearch>>> = ({
    signal,
  }) => repoSearch(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof repoSearch>>,
    TError,
    TData
  >;
};

export type RepoSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof repoSearch>>
>;
export type RepoSearchQueryError = AxiosError<ValidationError>;

/**
 * @summary Search for repositories
 */

export function useRepoSearch<
  TData = Awaited<ReturnType<typeof repoSearch>>,
  TError = AxiosError<ValidationError>,
>(
  params?: MaybeRef<RepoSearchParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof repoSearch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRepoSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >;

  return query;
}

/**
 * @summary Get a repository
 */
export const repoGet = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Repository>> => {
  owner = unref(owner);
  repo = unref(repo);

  return axios.default.get(`/repos/${owner}/${repo}`, options);
};

export const getRepoGetQueryKey = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
) => {
  return ["repos", owner, repo] as const;
};

export const getRepoGetQueryOptions = <
  TData = Awaited<ReturnType<typeof repoGet>>,
  TError = AxiosError<NotFound>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof repoGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getRepoGetQueryKey(owner, repo);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof repoGet>>> = ({
    signal,
  }) => repoGet(owner, repo, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo))),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof repoGet>>, TError, TData>;
};

export type RepoGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof repoGet>>
>;
export type RepoGetQueryError = AxiosError<NotFound>;

/**
 * @summary Get a repository
 */

export function useRepoGet<
  TData = Awaited<ReturnType<typeof repoGet>>,
  TError = AxiosError<NotFound>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof repoGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRepoGetQueryOptions(owner, repo, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >;

  return query;
}

/**
 * @summary Delete a repository
 */
export const repoDelete = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Empty>> => {
  owner = unref(owner);
  repo = unref(repo);

  return axios.default.delete(`/repos/${owner}/${repo}`, options);
};

export const getRepoDeleteMutationOptions = <
  TError = AxiosError<Forbidden | NotFound>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repoDelete>>,
    TError,
    { owner: string; repo: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof repoDelete>>,
  TError,
  { owner: string; repo: string },
  TContext
> => {
  const mutationKey = ["repoDelete"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof repoDelete>>,
    { owner: string; repo: string }
  > = (props) => {
    const { owner, repo } = props ?? {};

    return repoDelete(owner, repo, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RepoDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof repoDelete>>
>;

export type RepoDeleteMutationError = AxiosError<Forbidden | NotFound>;

/**
 * @summary Delete a repository
 */
export const useRepoDelete = <
  TError = AxiosError<Forbidden | NotFound>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof repoDelete>>,
      TError,
      { owner: string; repo: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof repoDelete>>,
  TError,
  { owner: string; repo: string },
  TContext
> => {
  return useMutation(getRepoDeleteMutationOptions(options), queryClient);
};

/**
 * @summary Edit a repository's properties. Only fields that are set will be changed.
 */
export const repoEdit = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  editRepoOption: MaybeRef<EditRepoOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Repository>> => {
  owner = unref(owner);
  repo = unref(repo);
  editRepoOption = unref(editRepoOption);

  return axios.default.patch(
    `/repos/${owner}/${repo}`,
    editRepoOption,
    options,
  );
};

export const getRepoEditMutationOptions = <
  TError = AxiosError<Forbidden | NotFound | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repoEdit>>,
    TError,
    { owner: string; repo: string; data: EditRepoOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof repoEdit>>,
  TError,
  { owner: string; repo: string; data: EditRepoOption },
  TContext
> => {
  const mutationKey = ["repoEdit"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof repoEdit>>,
    { owner: string; repo: string; data: EditRepoOption }
  > = (props) => {
    const { owner, repo, data } = props ?? {};

    return repoEdit(owner, repo, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RepoEditMutationResult = NonNullable<
  Awaited<ReturnType<typeof repoEdit>>
>;
export type RepoEditMutationBody = EditRepoOption;
export type RepoEditMutationError = AxiosError<
  Forbidden | NotFound | ValidationError
>;

/**
 * @summary Edit a repository's properties. Only fields that are set will be changed.
 */
export const useRepoEdit = <
  TError = AxiosError<Forbidden | NotFound | ValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof repoEdit>>,
      TError,
      { owner: string; repo: string; data: EditRepoOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof repoEdit>>,
  TError,
  { owner: string; repo: string; data: EditRepoOption },
  TContext
> => {
  return useMutation(getRepoEditMutationOptions(options), queryClient);
};

/**
 * @summary List a repository's issues
 */
export const issueListIssues = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IssueList>> => {
  owner = unref(owner);
  repo = unref(repo);
  params = unref(params);

  return axios.default.get(`/repos/${owner}/${repo}/issues`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getIssueListIssuesQueryKey = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
) => {
  return ["repos", owner, repo, "issues", ...(params ? [params] : [])] as const;
};

export const getIssueListIssuesQueryOptions = <
  TData = Awaited<ReturnType<typeof issueListIssues>>,
  TError = AxiosError<NotFound>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListIssues>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueListIssuesQueryKey(owner, repo, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueListIssues>>> = ({
    signal,
  }) => issueListIssues(owner, repo, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueListIssues>>,
    TError,
    TData
  >;
};

export type IssueListIssuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueListIssues>>
>;
export type IssueListIssuesQueryError = AxiosError<NotFound>;

/**
 * @summary List a repository's issues
 */

export function useIssueListIssues<
  TData = Awaited<ReturnType<typeof issueListIssues>>,
  TError = AxiosError<NotFound>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListIssues>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIssueListIssuesQueryOptions(
    owner,
    repo,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >;

  return query;
}

/**
 * @summary Create an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const issueCreateIssue = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  createIssueOption: MaybeRef<CreateIssueOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Issue>> => {
  owner = unref(owner);
  repo = unref(repo);
  createIssueOption = unref(createIssueOption);

  return axios.default.post(
    `/repos/${owner}/${repo}/issues`,
    createIssueOption,
    options,
  );
};

export const getIssueCreateIssueMutationOptions = <
  TError = AxiosError<
    Forbidden | NotFound | Error | ValidationError | RepoArchivedError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueCreateIssue>>,
    TError,
    { owner: string; repo: string; data: CreateIssueOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueCreateIssue>>,
  TError,
  { owner: string; repo: string; data: CreateIssueOption },
  TContext
> => {
  const mutationKey = ["issueCreateIssue"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueCreateIssue>>,
    { owner: string; repo: string; data: CreateIssueOption }
  > = (props) => {
    const { owner, repo, data } = props ?? {};

    return issueCreateIssue(owner, repo, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueCreateIssueMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueCreateIssue>>
>;
export type IssueCreateIssueMutationBody = CreateIssueOption;
export type IssueCreateIssueMutationError = AxiosError<
  Forbidden | NotFound | Error | ValidationError | RepoArchivedError
>;

/**
 * @summary Create an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const useIssueCreateIssue = <
  TError = AxiosError<
    Forbidden | NotFound | Error | ValidationError | RepoArchivedError
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueCreateIssue>>,
      TError,
      { owner: string; repo: string; data: CreateIssueOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueCreateIssue>>,
  TError,
  { owner: string; repo: string; data: CreateIssueOption },
  TContext
> => {
  return useMutation(getIssueCreateIssueMutationOptions(options), queryClient);
};

/**
 * @summary Get an issue
 */
export const issueGetIssue = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Issue>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);

  return axios.default.get(`/repos/${owner}/${repo}/issues/${index}`, options);
};

export const getIssueGetIssueQueryKey = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
) => {
  return ["repos", owner, repo, "issues", index] as const;
};

export const getIssueGetIssueQueryOptions = <
  TData = Awaited<ReturnType<typeof issueGetIssue>>,
  TError = AxiosError<NotFound>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof issueGetIssue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueGetIssueQueryKey(owner, repo, index);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueGetIssue>>> = ({
    signal,
  }) => issueGetIssue(owner, repo, index, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(index))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueGetIssue>>,
    TError,
    TData
  >;
};

export type IssueGetIssueQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueGetIssue>>
>;
export type IssueGetIssueQueryError = AxiosError<NotFound>;

/**
 * @summary Get an issue
 */

export function useIssueGetIssue<
  TData = Awaited<ReturnType<typeof issueGetIssue>>,
  TError = AxiosError<NotFound>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof issueGetIssue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIssueGetIssueQueryOptions(
    owner,
    repo,
    index,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >;

  return query;
}

/**
 * @summary Delete an issue
 */
export const issueDelete = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Empty>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);

  return axios.default.delete(
    `/repos/${owner}/${repo}/issues/${index}`,
    options,
  );
};

export const getIssueDeleteMutationOptions = <
  TError = AxiosError<Forbidden | NotFound>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueDelete>>,
    TError,
    { owner: string; repo: string; index: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueDelete>>,
  TError,
  { owner: string; repo: string; index: number },
  TContext
> => {
  const mutationKey = ["issueDelete"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueDelete>>,
    { owner: string; repo: string; index: number }
  > = (props) => {
    const { owner, repo, index } = props ?? {};

    return issueDelete(owner, repo, index, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueDelete>>
>;

export type IssueDeleteMutationError = AxiosError<Forbidden | NotFound>;

/**
 * @summary Delete an issue
 */
export const useIssueDelete = <
  TError = AxiosError<Forbidden | NotFound>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueDelete>>,
      TError,
      { owner: string; repo: string; index: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueDelete>>,
  TError,
  { owner: string; repo: string; index: number },
  TContext
> => {
  return useMutation(getIssueDeleteMutationOptions(options), queryClient);
};

/**
 * @summary Edit an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const issueEditIssue = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  editIssueOption: MaybeRef<EditIssueOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Issue>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  editIssueOption = unref(editIssueOption);

  return axios.default.patch(
    `/repos/${owner}/${repo}/issues/${index}`,
    editIssueOption,
    options,
  );
};

export const getIssueEditIssueMutationOptions = <
  TError = AxiosError<Forbidden | NotFound | Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueEditIssue>>,
    TError,
    { owner: string; repo: string; index: number; data: EditIssueOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueEditIssue>>,
  TError,
  { owner: string; repo: string; index: number; data: EditIssueOption },
  TContext
> => {
  const mutationKey = ["issueEditIssue"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueEditIssue>>,
    { owner: string; repo: string; index: number; data: EditIssueOption }
  > = (props) => {
    const { owner, repo, index, data } = props ?? {};

    return issueEditIssue(owner, repo, index, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueEditIssueMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueEditIssue>>
>;
export type IssueEditIssueMutationBody = EditIssueOption;
export type IssueEditIssueMutationError = AxiosError<
  Forbidden | NotFound | Error
>;

/**
 * @summary Edit an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const useIssueEditIssue = <
  TError = AxiosError<Forbidden | NotFound | Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueEditIssue>>,
      TError,
      { owner: string; repo: string; index: number; data: EditIssueOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueEditIssue>>,
  TError,
  { owner: string; repo: string; index: number; data: EditIssueOption },
  TContext
> => {
  return useMutation(getIssueEditIssueMutationOptions(options), queryClient);
};

/**
 * @summary Get the authenticated user
 */
export const userGetCurrent = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<User>> => {
  return axios.default.get(`/user`, options);
};

export const getUserGetCurrentQueryKey = () => {
  return ["user"] as const;
};

export const getUserGetCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetCurrent>>,
  TError = AxiosError<Unauthorized | Forbidden>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userGetCurrent>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getUserGetCurrentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetCurrent>>> = ({
    signal,
  }) => userGetCurrent({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetCurrent>>,
    TError,
    TData
  >;
};

export type UserGetCurrentQueryResult = NonNullable<
  Awaited<ReturnType<typeof userGetCurrent>>
>;
export type UserGetCurrentQueryError = AxiosError<Unauthorized | Forbidden>;

/**
 * @summary Get the authenticated user
 */

export function useUserGetCurrent<
  TData = Awaited<ReturnType<typeof userGetCurrent>>,
  TError = AxiosError<Unauthorized | Forbidden>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userGetCurrent>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUserGetCurrentQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >;

  return query;
}

/**
 * @summary List the specified user's access tokens
 */
export const userGetTokens = (
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccessTokenList>> => {
  username = unref(username);
  params = unref(params);

  return axios.default.get(`/users/${username}/tokens`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getUserGetTokensQueryKey = (
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
) => {
  return ["users", username, "tokens", ...(params ? [params] : [])] as const;
};

export const getUserGetTokensQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetTokens>>,
  TError = AxiosError<Forbidden | NotFound>,
>(
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userGetTokens>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getUserGetTokensQueryKey(username, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetTokens>>> = ({
    signal,
  }) => userGetTokens(username, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(username)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetTokens>>,
    TError,
    TData
  >;
};

export type UserGetTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof userGetTokens>>
>;
export type UserGetTokensQueryError = AxiosError<Forbidden | NotFound>;

/**
 * @summary List the specified user's access tokens
 */

export function useUserGetTokens<
  TData = Awaited<ReturnType<typeof userGetTokens>>,
  TError = AxiosError<Forbidden | NotFound>,
>(
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userGetTokens>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUserGetTokensQueryOptions(username, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >;

  return query;
}

/**
 * @summary Generate an access token for the specified user
 */
export const userCreateToken = (
  username: MaybeRef<string>,
  createAccessTokenOption: MaybeRef<CreateAccessTokenOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccessToken>> => {
  username = unref(username);
  createAccessTokenOption = unref(createAccessTokenOption);

  return axios.default.post(
    `/users/${username}/tokens`,
    createAccessTokenOption,
    options,
  );
};

export const getUserCreateTokenMutationOptions = <
  TError = AxiosError<Error | Forbidden | NotFound>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCreateToken>>,
    TError,
    { username: string; data: CreateAccessTokenOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userCreateToken>>,
  TError,
  { username: string; data: CreateAccessTokenOption },
  TContext
> => {
  const mutationKey = ["userCreateToken"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userCreateToken>>,
    { username: string; data: CreateAccessTokenOption }
  > = (props) => {
    const { username, data } = props ?? {};

    return userCreateToken(username, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserCreateTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof userCreateToken>>
>;
export type UserCreateTokenMutationBody = CreateAccessTokenOption;
export type UserCreateTokenMutationError = AxiosError<
  Error | Forbidden | NotFound
>;

/**
 * @summary Generate an access token for the specified user
 */
export const useUserCreateToken = <
  TError = AxiosError<Error | Forbidden | NotFound>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userCreateToken>>,
      TError,
      { username: string; data: CreateAccessTokenOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof userCreateToken>>,
  TError,
  { username: string; data: CreateAccessTokenOption },
  TContext
> => {
  return useMutation(getUserCreateTokenMutationOptions(options), queryClient);
};
